(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // Announcement bar close
  const announcementBar = document.querySelector('.announcement-bar');
  const announcementClose = document.querySelector('.announcement-close');
  const siteNav = document.querySelector('.site-nav');
  
  if (announcementClose && announcementBar) {
    announcementClose.addEventListener('click', () => {
      announcementBar.style.display = 'none';
      // Adjust site-nav top position when announcement bar is closed
      if (siteNav) {
        siteNav.style.top = (announcementBar.offsetHeight + 104) + 'px';
      }
    });
  }

 document.addEventListener('DOMContentLoaded', function() {
  // Get cart drawer elements
  const cartDrawerElement = document.querySelector('cart-drawer');
  const cartDrawerById = document.querySelector('#CartDrawer');
  
  // Function to open cart drawer using multiple approaches
  function openCartDrawer() {
    // Method 1: If cart-drawer custom element exists with open method
    if (cartDrawerElement && typeof cartDrawerElement.open === 'function') {
      cartDrawerElement.open();
      return;
    }
    
    // Method 2: Try adding open attribute to cart-drawer element
    if (cartDrawerElement && !cartDrawerElement.hasAttribute('open')) {
      cartDrawerElement.setAttribute('open', '');
      document.body.style.overflow = 'hidden';
      return;
    }
    
    // Method 3: Use the #CartDrawer element if available
    if (cartDrawerById) {
      cartDrawerById.classList.add('active');
      document.querySelector('.cart-drawer__overlay')?.classList.add('active');
      document.body.style.overflow = 'hidden';
      return;
    }
    
    // Method 4: If drawer is inside the DOM but hidden, try to show it
    const drawerContainer = document.querySelector('.cart-drawer');
    if (drawerContainer) {
      drawerContainer.classList.add('active');
      drawerContainer.style.transform = 'translateX(0)';
      document.body.style.overflow = 'hidden';
      return;
    }
    
    // Method 5: As a last resort, dispatch custom events that might be listened for
    document.dispatchEvent(new CustomEvent('cart:open', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('theme:cart:open', { bubbles: true }));
  }
  
  // Also listen for clicks on any add-to-cart buttons
  const addToCartButtons = document.querySelectorAll('[data-add-to-cart]');
  addToCartButtons.forEach(button => {
    button.addEventListener('click', function(e) {
      // Wait for the cart to update before opening drawer
      setTimeout(() => {
        openCartDrawer();
      }, 500);
    });
  });
  
  // Close drawer when clicking overlay
  const cartDrawerOverlay = document.querySelector('#CartDrawer-Overlay');
  if (cartDrawerOverlay) {
    cartDrawerOverlay.addEventListener('click', function() {
      if (cartDrawerElement && typeof cartDrawerElement.close === 'function') {
        cartDrawerElement.close();
      } else {
        cartDrawerById?.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
  
  // Add global accessibility for cart drawer
  window.openCartDrawer = openCartDrawer;
});

  // Mobile menu toggle
  const mobileMenuToggle = document.querySelector('.mobile-menu-toggle');

  if (mobileMenuToggle && siteNav) {
    mobileMenuToggle.addEventListener('click', () => {
      siteNav.classList.toggle('is-active');
      mobileMenuToggle.setAttribute('aria-expanded', 
        siteNav.classList.contains('is-active')
      );
    });
  }

  // Scroll handling
  let lastScroll = 0;
  const scrollThreshold = 10; // Minimum scroll amount before triggering

  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset;
    
    // Determine scroll direction and apply class if beyond threshold
    if (Math.abs(currentScroll - lastScroll) > scrollThreshold) {
      if (currentScroll > lastScroll && currentScroll > 200) {
        // Scrolling down & not at top
        siteNav.classList.add('nav-up');
      } else {
        // Scrolling up
        siteNav.classList.remove('nav-up');
      }
      lastScroll = currentScroll;
    }
  }, { passive: true });
  
  // Search functionality
  const searchToggle = document.querySelector('.search-toggle');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchClose = document.querySelector('.search-close');
  const searchInput = document.querySelector('.search-input');
  
  if (searchToggle && searchOverlay && searchClose) {
    // Open search overlay
    searchToggle.addEventListener('click', () => {
      searchOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent body scrolling
      // Focus on search input after a short delay to ensure the overlay is visible
      setTimeout(() => {
        if (searchInput) searchInput.focus();
      }, 100);
    });
    
    // Close search overlay
    searchClose.addEventListener('click', () => {
      searchOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore body scrolling
    });
    
    // Close search overlay on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchOverlay.classList.contains('active')) {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
    
    // Close search overlay when clicking outside of the search content
    searchOverlay.addEventListener('click', (e) => {
      if (e.target === searchOverlay) {
        searchOverlay.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }
  
  // Account functionality
  const accountToggle = document.querySelector('.account-toggle');
  const accountPopup = document.querySelector('.account-popup');
  const accountClose = document.querySelector('.account-close');
  const toggleRegister = document.querySelector('.toggle-register');
  const toggleLogin = document.querySelector('.toggle-login');
  const accountLogin = document.querySelector('.account-login');
  const accountRegister = document.querySelector('.account-register');
  
  if (accountToggle && accountPopup && accountClose) {
    // Open account popup
    accountToggle.addEventListener('click', () => {
      accountPopup.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent body scrolling
    });
    
    // Close account popup
    accountClose.addEventListener('click', () => {
      accountPopup.classList.remove('active');
      document.body.style.overflow = ''; // Restore body scrolling
    });
    
    // Close account popup on ESC key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && accountPopup.classList.contains('active')) {
        accountPopup.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
    
    // Switch between login and register forms
    if (toggleRegister && toggleLogin && accountLogin && accountRegister) {
      toggleRegister.addEventListener('click', (e) => {
        e.preventDefault();
        accountLogin.style.display = 'none';
        accountRegister.style.display = 'block';
      });
      
      toggleLogin.addEventListener('click', (e) => {
        e.preventDefault();
        accountRegister.style.display = 'none';
        accountLogin.style.display = 'block';
      });
    }
  }});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  // Add this script at the bottom of your cart.liquid template

document.addEventListener('DOMContentLoaded', function() {
  // Function to hide error messages after a delay
  function hideErrorsAfterDelay() {
    setTimeout(() => {
      // Hide the main cart error
      const cartErrors = document.getElementById('cart-errors');
      if (cartErrors) cartErrors.classList.add('hidden');
      
      // Hide any line item errors
      const lineItemErrors = document.querySelectorAll('[id^="Line-item-error-"]');
      lineItemErrors.forEach(error => {
        error.classList.add('hidden');
      });
    }, 500);
  }
  
  // Hook into the quantity change buttons
  const quantityButtons = document.querySelectorAll('.quantity__button');
  if (quantityButtons.length > 0) {
    quantityButtons.forEach(button => {
      button.addEventListener('click', function() {
        // After a quantity button is clicked, hide errors after a delay
        hideErrorsAfterDelay();
      });
    });
  }
  
  // Hook into quantity input field changes
  const quantityInputs = document.querySelectorAll('.quantity__input');
  if (quantityInputs.length > 0) {
    quantityInputs.forEach(input => {
      input.addEventListener('change', function() {
        // After a quantity input changes, hide errors after a delay
        hideErrorsAfterDelay();
      });
    });
  }
  
  // Hook into remove buttons
  const removeButtons = document.querySelectorAll('cart-remove-button a');
  if (removeButtons.length > 0) {
    removeButtons.forEach(button => {
      button.addEventListener('click', function() {
        // After a remove button is clicked, hide errors after a delay
        hideErrorsAfterDelay();
      });
    });
  }
  
  // Observe DOM changes to handle dynamically added elements
  const cartObserver = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
        // Check if any errors became visible
        const visibleErrors = document.querySelectorAll('.alert--error:not(.hidden)');
        if (visibleErrors.length > 0) {
          // If errors are shown but the cart updates correctly, hide them
          hideErrorsAfterDelay();
        }
      }
    }
  });
  
  // Start observing the cart container
  const cartContainer = document.getElementById('main-cart');
  if (cartContainer) {
    cartObserver.observe(cartContainer, { 
      childList: true,
      subtree: true
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-releases"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const cartButtons = document.querySelectorAll('.cart-button');
  
  cartButtons.forEach(button => {
    button.addEventListener('click', async function(event) {
      if (this.hasAttribute('disabled')) {
        return;
      }
      
      event.preventDefault();
      this.classList.add('adding');
      
      const variantId = this.getAttribute('data-variant-id');
      
      if (!variantId) {
        console.error('No variant ID found');
        this.classList.remove('adding');
        return;
      }
      
      try {
        const formData = {
          'items': [{
            'id': parseInt(variantId),
            'quantity': 1
          }]
        };

        // Show loading state
        const originalContent = this.innerHTML;
        this.innerHTML = '<div class="spinner"></div>';
        
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        });

        if (response.ok) {
          const data = await response.json();
          
          // Success animation
          this.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          
          // Try to open cart drawer using all possible methods available in the theme
          // Method 1: Theme's drawer opener
          if (typeof document.querySelector === 'function') {
            // Try to find and click the drawer trigger
            const drawerTrigger = document.querySelector('cart-drawer-trigger, .cart-drawer-trigger, [data-drawer-trigger="cart"], [data-action="open-drawer"][data-drawer-id="cart"]');
            if (drawerTrigger) {
              drawerTrigger.click();
            }
          }
          
          // Method 2: Theme's custom drawer JS
          if (typeof window.openCartDrawer === 'function') {
            window.openCartDrawer();
          } else if (typeof window.theme !== 'undefined') {
            // Check for various theme implementations
            if (typeof window.theme.openCartDrawer === 'function') {
              window.theme.openCartDrawer();
            } else if (typeof window.theme.Drawers !== 'undefined' && typeof window.theme.Drawers.open === 'function') {
              window.theme.Drawers.open('cart');
            }
          }
          
          // Method 3: Custom element methods
          const cartDrawer = document.querySelector('cart-drawer, .cart-drawer, #cart-drawer');
          if (cartDrawer) {
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else if (cartDrawer.hasAttribute('open') === false) {
              cartDrawer.setAttribute('open', '');
            } else if (cartDrawer.classList.contains('active') === false) {
              cartDrawer.classList.add('active');
            } else if (cartDrawer.classList.contains('is-active') === false) {
              cartDrawer.classList.add('is-active');
            }
          }
          
          // Method 4: Dispatch a custom event that the theme might be listening for
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          document.dispatchEvent(new CustomEvent('cart:added'));
          document.dispatchEvent(new CustomEvent('product:added-to-cart', { 
            detail: { product: data }
          }));
          
          // Update cart count if appropriate element exists
          const cartCountElements = document.querySelectorAll('.cart-count, .cart-count-bubble, [data-cart-count]');
          if (cartCountElements.length > 0) {
            // Fetch current cart to get updated count
            fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                cartCountElements.forEach(element => {
                  element.textContent = cart.item_count;
                  // Make sure it's visible
                  element.style.display = cart.item_count > 0 ? '' : 'none';
                });
              })
              .catch(error => console.error('Error updating cart count:', error));
          }
          
          // Revert back to original icon after a delay
          setTimeout(() => {
            this.innerHTML = originalContent;
            this.classList.remove('adding');
          }, 2000);
        } else {
          const errorData = await response.json();
          console.error('Error adding to cart:', errorData);
          // Revert to original state
          this.innerHTML = originalContent;
          this.classList.remove('adding');
          
          // Optional: Show error message to user
          alert(errorData.description || 'Error adding product to cart');
        }
      } catch (error) {
        console.error('Error:', error);
        this.innerHTML = originalContent;
        this.classList.remove('adding');
      }
    });
  });
});

// Add spinner styles
document.head.insertAdjacentHTML('beforeend', `
  <style>
    .cart-button.adding {
      pointer-events: none;
      opacity: 0.7;
    }
    .spinner {
      width: 18px;
      height: 18px;
      border: 2px solid rgba(0, 0, 0, 0.1);
      border-top-color: #000;
      border-radius: 50%;
      animation: spinner 0.6s linear infinite;
    }
    @keyframes spinner {
      to {transform: rotate(360deg);}
    }
  </style>
`);

  } catch(e) { console.error(e); }
})();
})();
